export default __webpack_public_path__ + "static/layout-anatomy-light-54f7170ad312d58291f5ac4814d0a285b5bb0bc68505cf6b0a2c67bee3cca05d.png";